import { Auth } from '@loca/mfe-vue3'

Auth.config.userInfoApiPath = '/pe/gatekeeper/user/info'
Auth.config.ssoAccessTokenApiPath = '/pe/gatekeeper/sso/authorize'

// 权限列表，通过有意义的字符串名称来供全局读取
export const permissionList = {
  // 根权限
  POWERPRO_ROOT: 'pe:powerpro:root',
  // 首页指标查看权限
  HOME_ROOT: 'powerpro:home:root',
}
